import { useCallback, useEffect, useRef, useState } from 'react';

import companyEndpoints from '../../../../api/services/companyEndpoints';
import CompanyListHelper from '../../helpers/list-helpers';

export const useFetchCompanies = (config = {boStrip: false, boWithUsers: false}) => {
  const [loading, setLoading] = useState();
  const [companies, setCompanies] = useState([]);
  const isMounted = useRef(true);

  const fetchAllCompanies = useCallback(async () => {
    setLoading(true);
    if (companies.length === 0) {
      try {
        let response;
        if (config.boStrip) {
          response = await companyEndpoints.getAllStripCompanies();
        } else {
          if(config.boWithUsers) {
            response = await companyEndpoints.getAllCompaniesAndUsers();
          } else {
            response = await companyEndpoints.getAllCompanies();
          }
        }
        if(response.status === 200) {
          if(isMounted.current) setCompanies(CompanyListHelper.parseDocumentNumber(response.data))
        }
      } finally {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchAllCompanies().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllCompanies]);

  return {
    loading,
    companies,
  };
};
